import {useMutation} from '@tanstack/react-query';

import {getHealthOpenScheduling} from 'presentation/services/getHealthOpenScheduling';

export const useGetHealthOpenSchedulingMutation = () => {
	return useMutation({
		mutationFn: getHealthOpenScheduling,
	});
};
